import { createContext, useState, useContext } from 'react';

const QuestionContext = createContext();

export function QuestionProvider({ children }) {
    const [sharedQuestion, setSharedQuestion] = useState('');

    return (
        <QuestionContext.Provider value={{ sharedQuestion, setSharedQuestion }}>
            {children}
        </QuestionContext.Provider>
    );
}

export function useQuestion() {
    return useContext(QuestionContext);
} 